import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016A35 35 0 0 1 31.822 20H.166a36 36 0 0 1-.163-4.017A35 35 0 0 1 .178 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M16 25.333c1.244 0 4.667-4.178 4.667-9.333S17.244 6.667 16 6.667 11.334 10.845 11.334 16s3.422 9.333 4.666 9.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M19.89 20.299c-.742-.971-1.223-2.535-1.223-4.299s.481-3.328 1.224-4.299A12.7 12.7 0 0 1 20.667 16c0 1.55-.31 3.012-.776 4.299m-7.78-8.597c.742.97 1.224 2.534 1.224 4.298s-.482 3.328-1.224 4.299A12.7 12.7 0 0 1 11.334 16c0-1.55.309-3.012.776-4.299",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 17.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 14.667s1.333-1.791 1.333-4-1.333-4-1.333-4-1.334 1.79-1.334 4 1.334 4 1.334 4m0 10.666s1.333-1.79 1.333-4-1.333-4-1.333-4-1.334 1.791-1.334 4 1.334 4 1.334 4",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagKen = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagKen_default = SvgFlagKen;

export { FlagKen_default as default };
